import { render, staticRenderFns } from "./DesignerView.vue?vue&type=template&id=04be7b52&"
import script from "./DesignerView.vue?vue&type=script&lang=js&"
export * from "./DesignerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports